<template>
	<tfoot class="fd-pager">
		<tr>
			<th :colspan="span" class="tablepager">
				<div class="tablepager-content">
					<span class="pagercontrols">
						<icon-button name="page-first-16-bold" @click="goFirst"></icon-button>
						<icon-button name="page-prev-16-bold" @click="goPrev"></icon-button>
						<input class="agenda-slider" type="range" min="0" :max="max" step="1" v-model="localPos" @change="localChanged"/>
						<icon-button name="page-next-16-bold" @click="goNext"></icon-button>
						<icon-button name="page-last-16-bold" @click="goLast"></icon-button>
						{{ modelValue+1 }} - {{ Math.min(modelValue+page, total) }} {{ totalInfo }}
					</span>
					<span class="chart-list"></span>
					<span class="tablesetting"></span>
				</div>
			</th>
		</tr>
	</tfoot>
</template>

<script setup lang="ts">
import IconButton from "../../helpers/IconButton.vue";
import {computed, ref, watch} from "vue";
import {injectSelection} from "./RowSelection";

const props = defineProps({
	/* How many columns to span */
	span: Number,
	/* Current position */
	modelValue: {
        type: Number,
        default: 0
    },
	/* Page size */
	page: {
        type: Number,
		default: 20
    },
	/* Total number of records */
	total: {
        type: Number,
		default: 0
    }
});
const emit = defineEmits(["update:modelValue"]);

const max = computed<number>(() => Math.max(0, props.total - props.page));
const localPos = ref<number>(0);
const sel = injectSelection();

const totalInfo = computed(() => {
	const selected = sel.count(props.total);
	if (selected > 0) {
		return "(" + selected + " / " + props.total + ")";
	} else {
		return "(" + props.total + ")";
	}
});

function localChanged() {
    if (props.modelValue !== localPos.value) {
        emit("update:modelValue", localPos.value);
    }
}

function goFirst() {
    localPos.value = 0;
    localChanged();
}

function goLast() {
    localPos.value = max.value;
    localChanged();
}

function goPrev(e:MouseEvent) {
    const smallStep = e.shiftKey;
    localPos.value = Math.max(localPos.value - (smallStep ? 1 : props.page), 0);
    localChanged();
}
function goNext(e:MouseEvent) {
    const smallStep = e.shiftKey;
    localPos.value = Math.min(localPos.value + (smallStep ? 1 : props.page), max.value);
    localChanged();
}

watch(() => props.modelValue, (pos) => localPos.value = pos);
</script>

<style>
.fd-pager {
	user-select: none;
	-webkit-user-select: none;
}
</style>
